import { type FC } from 'react';

import NoodleAI from '@/components/Icons/NoodleAI';

import s from './GeneratedByNoodleAi.module.scss';

const GeneratedByNoodleAi: FC<{ creatorName: string }> = ({ creatorName }) => (
  <div className={s.wrapper}>
    <div className={s.badge}>
      <NoodleAI size={12} />
      Generated by Glade AI
    </div>
    <p className='caption'>
      Please do not take any actions based on the output of this AI Agent. Please consult your service provider{' '}
      {creatorName} for clarity.
    </p>
  </div>
);

export default GeneratedByNoodleAi;
